import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import EndpointView from './pages/EndpointView';
import Base64Encoding from './pages/Base64Encoding';
import UrlEncoding from './pages/UrlEncoding';
import XmlEncoding from './pages/XmlEncoding';
import JsonYamlConverter from './pages/JsonYamlConverter';
import HashGenerator from './pages/HashGenerator';
import JwtDecoder from './pages/JwtDecoder';
import UuidGenerator from './pages/UuidGenerator';
import TimestampConverter from './pages/TimestampConverter';
import RegexTester from './pages/RegexTester';
import ToolsIndex from './pages/ToolsIndex';
import NotFound from './pages/NotFound';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import './theme.css';
import './components/layout/layout.css';
import './App.css';

function App() {
  const [darkMode, setDarkMode] = useState(() => {
    const saved = localStorage.getItem('darkMode');

    // If user has a saved preference, use it
    if (saved !== null) {
      return JSON.parse(saved);
    }

    // Otherwise, check system preference
    if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
      return true;
    }

    // Fallback: check time of day (dark mode between 6 PM and 6 AM)
    const hour = new Date().getHours();
    return hour >= 18 || hour < 6;
  });

  useEffect(() => {
    const html = document.documentElement;
    if (darkMode) {
      html.setAttribute('data-bs-theme', 'dark');
    } else {
      html.removeAttribute('data-bs-theme');
    }
    localStorage.setItem('darkMode', JSON.stringify(darkMode));
  }, [darkMode]);

  const toggleDarkMode = () => {
    setDarkMode(!darkMode);
  };

  return (
      <Router>
        <div className="App">
          <Navigation darkMode={darkMode} onToggleDarkMode={toggleDarkMode} />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/endpoint/:slug" element={<EndpointView />} />
              <Route path="/base64" element={<Base64Encoding />} />
              <Route path="/url-encoding" element={<UrlEncoding />} />
              <Route path="/xml-encoding" element={<XmlEncoding />} />
              <Route path="/json-yaml" element={<JsonYamlConverter />} />
              <Route path="/hash" element={<HashGenerator />} />
              <Route path="/jwt" element={<JwtDecoder />} />
              <Route path="/uuid" element={<UuidGenerator />} />
              <Route path="/timestamp" element={<TimestampConverter />} />
              <Route path="/regex" element={<RegexTester />} />
              <Route path="/tools" element={<ToolsIndex />} />
              {/* Catch-all: any undeclared path gets the Not Found page, not a
                  blank <main>. Keep this last so it cannot shadow a real route. */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
  );
}

export default App;
